export const analyticsState = {
  analyticsData: {
    metrics: {
      'New Users': {},
      'Bounce Rate': {},
      Sessions: {},
      'Pages/Session': {},
      'Avg. Session Duration': {},
      'Page Views': {},
    },
    newVisitors: [],
    sessions: [],
    socialSources: {},
    devices: {},
    newVisitorsByState: [],
    topLanding: [],
    events: [],
    pageViews: [],
  },
};

export const analyticsReducer = {
  // google analytics
  FETCHING_GA_SITE_METRICS_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        metrics: payload,
      },
    },
  }),
  FETCHING_GA_NEW_VISITORS_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        newVisitors: payload,
      },
    },
  }),
  FETCHING_GA_SESSIONS_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        sessions: payload,
      },
    },
  }),
  FETCHING_GA_EVENTS_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        events: payload,
      },
    },
  }),
  FETCHING_GA_SOCIAL_SOURCES_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        socialSources: payload,
      },
    },
  }),
  FETCHING_GA_DEVICES_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        devices: payload,
      },
    },
  }),
  FETCHING_GA_NEW_VISITORS_BY_STATE_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        newVisitorsByState: payload,
      },
    },
  }),
  FETCHING_GA_TOP_LANDING_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        topLanding: payload,
      },
    },
  }),
  FETCHING_GA_PAGE_VIEWS_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      analyticsData: {
        ...state.show.analyticsData,
        pageViews: payload,
      },
    },
  }),
};
